import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/Index.vue';
import Main from '@/components/pages/Main';
import Now from '@/components/pages/NowState';
import Compare from '@/components/pages/Compare';
import Count from '@/components/pages/Count';
import Member from '@/components/pages/Member';
import Calendar from '@/components/pages/Calendar';
import Setting from '@/components/pages/Setting';
import Multiorder from '@/components/pages/Multiorder';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path: '',
      component: Index,
      children: [{
          path: '/',
          // component: Main,
          component: () =>
            import(
              /* webpackChunkName: "Main" */
              './components/pages/Main.vue'
            ),
          // meta: { requiresAuth: true }
        },
        {
          path: '/now',
          // component: Now,
          component: () =>
            import(
              /* webpackChunkName: "Now" */
              './components/pages/NowState.vue'
            ),
          // meta: { requiresAuth: true }
        },
        {
          path: '/compare/:dep',
          component: Compare,
          // meta: { requiresAuth: true }
        },
        {
          path: '/multiorder/:dep',
          // component: Multiorder,
          component: () =>
            import(
              /* webpackChunkName: "multiorder" */
              './components/pages/Multiorder.vue'
            ),
          // meta: { requiresAuth: true }
        },
        {
          path: '/count/:dep',
          component: Count,
          // meta: { requiresAuth: true }
        },
        {
          path: '/member/:dep',
          component: Member,
          // meta: { requiresAuth: true }
        },
        {
          path: '/calendar/:dep',
          component: Calendar,
          // meta: { requiresAuth: true }
        },
        {
          path: '/setting',
          component: Setting,
          // meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});